var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStodarLoadingCogsLarge02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 348.22 311.81",
    style: {
      enableBackground: "new 0 0 348.22 311.81"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#1D71B8;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#000000;stroke-width:4;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:none;stroke:#1D71B8;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st5{fill:#FFFFFF;stroke:#000000;stroke-width:5;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CogSmall_00000116952871395315259470000010650240104709837703_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "CogLarge_00000032641367015544127200000015591554807829428907_",
    className: "st5",
    d: "M278.14,146.91v-7.11l-27.51-6.03 c-1.65-5.73-3.93-11.19-6.76-16.3l15.19-23.72l-22.79-22.79l-23.72,15.19c-5.12-2.83-10.58-5.11-16.3-6.76l-6.03-27.51h-32.23 l-6.03,27.51c-5.72,1.65-11.18,3.93-16.3,6.76l-23.72-15.19L89.15,93.73l15.19,23.72c-2.83,5.12-5.11,10.58-6.76,16.3 l-27.51,6.03v32.23l27.51,6.03c1.65,5.73,3.94,11.19,6.76,16.31l-15.19,23.72l22.79,22.79l23.72-15.18 c5.12,2.82,10.58,5.1,16.3,6.76l6.03,27.51h13.88h6.12h12.23l6.03-27.51c5.72-1.65,11.18-3.93,16.3-6.76l23.72,15.19l22.79-22.79 l-15.19-23.72c2.83-5.12,5.11-10.58,6.76-16.3l27.51-6.03v-22.23V146.91z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 174 155",
    to: "360 174 155",
    dur: "30s",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.76,158.47c-0.05,3.02-2.54,5.42-5.56,5.37c-3.02-0.05-5.42-2.54-5.37-5.56 c0.05-3.01,2.54-5.42,5.56-5.37C217.41,152.96,219.81,155.45,219.76,158.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M178.9,196.41c-0.05,3.02-2.54,5.42-5.56,5.37c-3.02-0.05-5.42-2.54-5.37-5.56 c0.05-3.02,2.54-5.42,5.56-5.37C176.54,190.9,178.95,193.39,178.9,196.41z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "CogLargeInside_00000152253241472943490830000014419362920392408508_",
    className: "st0",
    d: "M186.08,155.93 c0,6.61-5.36,11.97-11.97,11.97c-6.61,0-11.97-5.36-11.97-11.97c0-6.61,5.36-11.97,11.97-11.97 C180.72,143.96,186.08,149.32,186.08,155.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.74,154.87c-0.87-22.41-19.74-39.87-42.15-39c-22.41,0.87-39.87,19.74-39,42.15 c0.79,20.31,16.37,36.53,35.96,38.74"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 181.39,
    y1: 164.96,
    x2: 196.13,
    y2: 180.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M171.88,214.33c-31.25-1.17-56.22-26.86-56.22-58.39c0-32.29,26.17-58.46,58.45-58.46 c32.28,0,58.44,26.17,58.45,58.45"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStodarLoadingCogsLarge02);
export default __webpack_public_path__ + "static/media/Stodar_Loading_Cogs_Large-02.72ebec64545f40ba25479b970e60bb9e.svg";
export { ForwardRef as ReactComponent };